<template>
  <component
    :is="component"
    @scroll-to="$emit('scroll-to', $event)"
    @onnextstep="$emit('onnextstep', $event)"
    @ontimesnearby="$emit('ontimesnearby', $event)"
    @onbookerror="$emit('onbookerror', $event)"
    @on:ocr_scan="$emit('on:ocr_scan', $event)"
    @on:submitted="$emit('on:submitted', $event)"
    @on:book_success="$emit('on:book_success', $event)"
  ></component>
</template>

<script>
import AppControllerMulti from "@/components/AppController/AppControllerMulti";
import AppControllerSingle from "@/components/AppController/AppControllerSingle";

export default {
  props: ["search"],
  components: {
    AppControllerMulti,
    AppControllerSingle,
  },
  computed: {
    type() {
      return this.$store.getters.isSingleLocation ? "single" : "multi";
    },
    component() {
      return "app-controller-" + this.type;
    },
  },
  created() {
    this.$store.commit("fieldUpdate", {
      value: { ...this.$store.state.config, ...this.search },
      key: "config",
    });
  },
};
</script>
